import axios from "axios";
import serialize from "json-form-data";
import { param } from "@/utils/url/param";
import { reformatDateForServer } from "@/helpers/workWithDates";

const api_url = "/index.php";

const codes = {
    worker: 1,
    calc: 2,
    personal: 4
};

const getApi = (ctx) => {
    const { rootState, commit, state } = ctx;
    const { authToken: token } = rootState;

    const root = api_url;
    return {
        root,
        state,
        token,
        commit,
        url: (action, params = {}) => {
            const paramsString = param(params);
            return `${root}?r=${action}&auth_key=${token}&${paramsString}`;
        },
    };
};

const actions = {
    async fetchReportSettings(ctx, params = {}) {
        const { url } = getApi(ctx);
        const { startDate, endDate, report } = params;
        const formattedParams = {
            from_dt: startDate && reformatDateForServer(startDate),
            to_dt: endDate && reformatDateForServer(endDate),
            report,
        };

        const { data } = await axios.get(url("api/reports/olap/index", formattedParams));

        return data;
    },

    async saveReportSettings(ctx, params = {}) {
        const { url } = getApi(ctx);

        const { code, ...otherParams } = params;
        const actionParams = {
            ...otherParams,
            element_id: codes[code],
        };

        const { data } = await axios.get(url("api/reports/olap/save", actionParams));

        return data;
    },

    async getReport(ctx, params = {}) {
        const { url } = getApi(ctx);
        const { id } = params;
        const { data } = await axios.get(url("api/reports/olap/view", { id }));
        return data;
    },

    async createReport(ctx, reportData = {}) {
        const { url } = getApi(ctx);
        const { files, code, ...params } = reportData;
        const formData = serialize({
            ...params,
            element_id: codes[code]
        });

        files.forEach((file) => {
            formData.append("files[]", file);
        });

        const { data } = await axios.post(url("api/reports/olap/create"), formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return data;
    },

    async editReport(ctx, reportData = {}) {
        const { url } = getApi(ctx);
        const { id, files, code, ...params } = reportData;


        const formData = serialize(params);
        if (!params.responsible_id) {
            formData.append("responsible_id", '')
        }
        if (!params.category_id) {
            formData.append("category_id", '')
        }

        files.forEach((file) => {
            formData.append("files[]", file);
        });

        const { data } = await axios.put(url("api/reports/olap/update", { id, element_id: codes[code] }), formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return data;
    },

    async removeReport({ rootState }, params) {
        const token = rootState.authToken;

        const { reportId } = params;

        const res = await fetch(`${api_url}?r=api/reports/olap/remove&auth_key=${token}&id=${reportId}`);
        const json = await res.json();

        return json;
    },

    async getCategories(ctx, params = {}) {
        const { url } = getApi(ctx);
        const { search, code } = params;

        const { data } = await axios.get(
            url("api/reports/olap-report-category/index", { search: search || "", element_id: codes[code] }),
        );
        return data;
    },

    async getReportsInCategory(ctx, params = {}) {
        const { url } = getApi(ctx);
        const { categoryId, search, code } = params;
        const requestParams = {
            category_id: categoryId || "",
            search: search || "",
            element_id: codes[code],
        };
        const { data } = await axios.get(url("api/reports/olap/get-reports", requestParams));
        return data;
    },

    async createCategory(ctx, params = {}) {
        const { url } = getApi(ctx);
        const { name, code } = params;
        const { data } = await axios.post(url("api/reports/olap-report-category/create"), {
            name,
            element_id: codes[code],
        });
        return data;
    },

    async editCategory(ctx, params = {}) {
        const { url } = getApi(ctx);
        const { categoryId, name } = params;
        const { data } = await axios.post(url("api/reports/olap-report-category/update", { id: categoryId }), {
            name,
        });
        return data;
    },

    async changeReportCategory(ctx, params = {}) {
        const { url } = getApi(ctx);
        const { reportId, categoryId, code } = params;
        const { data } = await axios.post(url("api/reports/olap/update", { id: reportId, element_id: codes[code] }), {
            category_id: categoryId || null,
        });
        return data;
    },

    async resortCategories(ctx, order) {
        const { url } = getApi(ctx);
        const newOrder = order.map((categoryId, i) => ({ id: categoryId, sort: i }));
        const { data } = await axios.patch(url("api/reports/olap-report-category/update-sort"), newOrder);
        return data;
    },

    async resortReports(ctx, order) {
        const { url } = getApi(ctx);
        const newOrder = order.map((reportId, i) => ({ id: reportId, sort: i }));
        const { data } = await axios.patch(url("api/reports/olap/update-sort"), newOrder);
        return data;
    },

    async removeCategory(ctx, categoryId) {
        const { url } = getApi(ctx);
        const { data } = await axios.delete(url("api/reports/olap-report-category/delete", { id: categoryId }));
        return data;
    },

    async getWorkers(ctx) {
        const { url } = getApi(ctx);
        const { data } = await axios.get(url("api/worker/index", { sort: "name", pagination: 0, job_status: 1 }));
        return data;
    },
};

export default {
    namespaced: true,
    actions,
};
